<template>
  <button class="btn btn-sm btn-circle btn-ghost absolute right-2 top-2 text-black">
    ✕
  </button>
</template>
